import MessageModel from "../Domain/Message.model";
import { createNewMessageByChatService } from "../Infrastructure/Chat.service";
import { listConversation } from "./listConversation.logic";

export default async function sendMessage(chatID, message, userID) {
  const messageToSend = {
    chat_id: chatID,
    content: message,
    messageUser_idId: userID,
  };

  await createNewMessageByChatService(messageToSend);
  await listConversation();
}
